import { Catalog } from '@/types/Catalog';
import { CatalogBidIncrements } from '@/types/BidIncrement';
import { CoverLot } from '@/types/CoverLot';
import { Seller } from '@/types/Seller';
import ms from 'ms';

export const CATALOG_SLICE_CACHE_TIME = ms('30m');

export type PostFetchCatalogsByIdsPayload = {
    bidIncrements: CatalogBidIncrements[];
    catalogs: Catalog[];
    coverLots: CoverLot[];
    sellers: Seller[];
};

export type CatalogSlice = {
    byId: { [catalogId: number]: Catalog };
    loaded: { [catalogId: number]: number };
    loading: number[];
};

export const defaultCatalogSlice: CatalogSlice = {
    byId: {},
    loaded: {},
    loading: [],
};
